<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Add Cms</h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(cmsSubmit)" id="basic-form">
                <div class="body">
                  <ValidationProvider
                    name="cms_name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !cms.name,
                        success: cms.name,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="cms.name"
                          class="form-control"
                          placeholder="Cms Name"
                        />
                        <label for="cms" class="control-label">Cms Name*</label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !cms.name"
                        ></i>
                        <i class="fa fa-check" v-if="cms.name"></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <div class="form-group" :class="{ success: cms.meta_title }">
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="cms.meta_title"
                        class="form-control"
                        placeholder="Meta title"
                      />
                      <label for="cms" class="control-label">Meta title</label>
                      <div class="line"></div>
                      <i class="fa fa-check" v-if="cms.meta_title"></i>
                    </span>
                  </div>
                  <div
                    class="form-group"
                    :class="{ success: cms.meta_keywords }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="cms.meta_keywords"
                        class="form-control"
                        placeholder="Meta keywords"
                      />
                      <label for="cms" class="control-label">
                        Meta keywords
                      </label>
                      <div class="line"></div>
                      <i class="fa fa-check" v-if="cms.meta_keywords"></i>
                    </span>
                  </div>
                  <div
                    class="form-group"
                    :class="{ success: cms.meta_description }"
                  >
                    <span class="float-label">
                      <textarea
                        type="text"
                        v-model="cms.meta_description"
                        class="form-control"
                        placeholder="Meta title"
                      ></textarea>
                      <label for="cms" class="control-label">Meta title</label>
                      <div class="line"></div>
                      <i class="fa fa-check" v-if="cms.meta_description"></i>
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="cms_page_body" class="control-label">
                      Page Body
                    </label>
                    <span class="float-label">
                      <vue-editor v-model="cms.page_body"></vue-editor>
                    </span>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { VueEditor } = require("vue2-editor");
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "AddCmsComponent",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    VueEditor,
  },
  data() {
    return {
      cms: {
        name: "",
        meta_title: "",
        meta_keywords: "",
        meta_description: "",
        page_body: "",
      },
    };
  },
  methods: {
    cmsSubmit() {
      console.log(this.cms);
    },
  },
  mounted() {},
};
</script>
